import { Component } from "react";
import { Card } from "semantic-ui-react";
import { useReferenceInfo } from "../../providers/ReferenceInfoProvider";

const TermsOfUse = () => {
	const { currentInfo } = useReferenceInfo();
	return (
		<Card fluid>
			<Card.Content>
				<h4 className="title-card">Terms of Use </h4>
			</Card.Content>
			<Card.Content>

				<p>
					These terms of use ("Terms") outline the rules and guidelines for accessing and using the ESVD. 
					By accessing or using the ESVD, you agree to comply with these Terms. 
					If you do not agree with any part of these Terms, you may not access or use the ESVD.
				</p>
				<ol
				  style={{
						paddingLeft: 0,
						marginLeft: 12,
						// listStyle: "none",
					}}
				>
					<li>
						Permitted Use
						<p>
						The ESVD is intended for non-commercial, research, and educational purposes aimed at supporting more sustainable ecosystem management and policy-making. 
						You may access and use the ESVD data solely for these purposes. Commercial use of the ESVD data is subject to separate terms and conditions as outlined below.
						</p><br/>
					</li>
					<li>
						Attribution
						<p>
							If you use ESVD data in reports or publications, you must make them publicly available and properly cite the source using the following format:
							<br/>
							<br/>
							"Brander, L.M., de Groot, R., Guisado Goñi, V., van 't Hoff, V., Schägner, P., Solomonides, S., McVittie, A., Eppink, F., Sposato, M., Do, L., Ghermandi, A., and Sinclair, M. (2023). Ecosystem Services Valuation Database (ESVD). Foundation for Sustainable Development and Brander Environmental Economics."
						</p><br/>
					</li>
					<li>
						Restrictions
						<p>
					
									You may not modify, distribute, transmit, or create derivative works based on the ESVD data without prior written consent from FSD.
								<br/><br/>
									You may not attempt to reverse engineer, decompile, or disassemble any software used in connection with the ESVD.
								<br/><br/>
									You may not remove or alter any copyright, trademark, or other proprietary notices contained in the ESVD data.
								
						</p>
					</li>
				</ol>
			</Card.Content>
		</Card>
	);
};

export default TermsOfUse;
